export interface CountryPhoneCode {
  code: string;
  alpha3?: string; // 3-letter ISO code for display
  name: string;
  flag: string;
  phoneCode: string;
  dialCode: string;
}

export const countryPhoneCodes: CountryPhoneCode[] = [
  { code: 'AF', alpha3: 'AFG', name: 'Afghanistan', flag: '🇦🇫', phoneCode: '+93', dialCode: '93' },
  { code: 'AL', alpha3: 'ALB', name: 'Albania', flag: '🇦🇱', phoneCode: '+355', dialCode: '355' },
  { code: 'DZ', alpha3: 'DZA', name: 'Algeria', flag: '🇩🇿', phoneCode: '+213', dialCode: '213' },
  {
    code: 'AS',
    alpha3: 'ASM',
    name: 'American Samoa',
    flag: '🇦🇸',
    phoneCode: '+1684',
    dialCode: '1684',
  },
  { code: 'AD', alpha3: 'AND', name: 'Andorra', flag: '🇦🇩', phoneCode: '+376', dialCode: '376' },
  { code: 'AO', alpha3: 'AGO', name: 'Angola', flag: '🇦🇴', phoneCode: '+244', dialCode: '244' },
  { code: 'AI', alpha3: 'AIA', name: 'Anguilla', flag: '🇦🇮', phoneCode: '+1264', dialCode: '1264' },
  {
    code: 'AG',
    alpha3: 'ATG',
    name: 'Antigua and Barbuda',
    flag: '🇦🇬',
    phoneCode: '+1268',
    dialCode: '1268',
  },
  { code: 'AR', alpha3: 'ARG', name: 'Argentina', flag: '🇦🇷', phoneCode: '+54', dialCode: '54' },
  { code: 'AM', alpha3: 'ARM', name: 'Armenia', flag: '🇦🇲', phoneCode: '+374', dialCode: '374' },
  { code: 'AU', alpha3: 'AUS', name: 'Australia', flag: '🇦🇺', phoneCode: '+61', dialCode: '61' },
  { code: 'AT', alpha3: 'AUT', name: 'Austria', flag: '🇦🇹', phoneCode: '+43', dialCode: '43' },
  { code: 'AZ', alpha3: 'AZE', name: 'Azerbaijan', flag: '🇦🇿', phoneCode: '+994', dialCode: '994' },
  { code: 'BS', alpha3: 'BHS', name: 'Bahamas', flag: '🇧🇸', phoneCode: '+1242', dialCode: '1242' },
  { code: 'BH', alpha3: 'BHR', name: 'Bahrain', flag: '🇧🇭', phoneCode: '+973', dialCode: '973' },
  { code: 'BD', alpha3: 'BGD', name: 'Bangladesh', flag: '🇧🇩', phoneCode: '+880', dialCode: '880' },
  { code: 'BB', alpha3: 'BRB', name: 'Barbados', flag: '🇧🇧', phoneCode: '+1246', dialCode: '1246' },
  { code: 'BY', alpha3: 'BLR', name: 'Belarus', flag: '🇧🇾', phoneCode: '+375', dialCode: '375' },
  { code: 'BE', alpha3: 'BEL', name: 'Belgium', flag: '🇧🇪', phoneCode: '+32', dialCode: '32' },
  { code: 'BZ', alpha3: 'BLZ', name: 'Belize', flag: '🇧🇿', phoneCode: '+501', dialCode: '501' },
  { code: 'BJ', alpha3: 'BEN', name: 'Benin', flag: '🇧🇯', phoneCode: '+229', dialCode: '229' },
  { code: 'BM', alpha3: 'BMU', name: 'Bermuda', flag: '🇧🇲', phoneCode: '+1441', dialCode: '1441' },
  { code: 'BT', alpha3: 'BTN', name: 'Bhutan', flag: '🇧🇹', phoneCode: '+975', dialCode: '975' },
  { code: 'BO', alpha3: 'BOL', name: 'Bolivia', flag: '🇧🇴', phoneCode: '+591', dialCode: '591' },
  {
    code: 'BA',
    alpha3: 'BIH',
    name: 'Bosnia and Herzegovina',
    flag: '🇧🇦',
    phoneCode: '+387',
    dialCode: '387',
  },
  { code: 'BW', alpha3: 'BWA', name: 'Botswana', flag: '🇧🇼', phoneCode: '+267', dialCode: '267' },
  { code: 'BR', alpha3: 'BRA', name: 'Brazil', flag: '🇧🇷', phoneCode: '+55', dialCode: '55' },
  {
    code: 'BN',
    alpha3: 'BRN',
    name: 'Brunei Darussalam',
    flag: '🇧🇳',
    phoneCode: '+673',
    dialCode: '673',
  },
  { code: 'BG', alpha3: 'BGR', name: 'Bulgaria', flag: '🇧🇬', phoneCode: '+359', dialCode: '359' },
  {
    code: 'BF',
    alpha3: 'BFA',
    name: 'Burkina Faso',
    flag: '🇧🇫',
    phoneCode: '+226',
    dialCode: '226',
  },
  { code: 'BI', alpha3: 'BDI', name: 'Burundi', flag: '🇧🇮', phoneCode: '+257', dialCode: '257' },
  { code: 'KH', alpha3: 'KHM', name: 'Cambodia', flag: '🇰🇭', phoneCode: '+855', dialCode: '855' },
  { code: 'CM', alpha3: 'CMR', name: 'Cameroon', flag: '🇨🇲', phoneCode: '+237', dialCode: '237' },
  { code: 'CA', alpha3: 'CAN', name: 'Canada', flag: '🇨🇦', phoneCode: '+1', dialCode: '1' },
  { code: 'CV', alpha3: 'CPV', name: 'Cape Verde', flag: '🇨🇻', phoneCode: '+238', dialCode: '238' },
  {
    code: 'CF',
    alpha3: 'CAF',
    name: 'Central African Republic',
    flag: '🇨🇫',
    phoneCode: '+236',
    dialCode: '236',
  },
  { code: 'TD', alpha3: 'TCD', name: 'Chad', flag: '🇹🇩', phoneCode: '+235', dialCode: '235' },
  { code: 'CL', alpha3: 'CHL', name: 'Chile', flag: '🇨🇱', phoneCode: '+56', dialCode: '56' },
  { code: 'CN', alpha3: 'CHN', name: 'China', flag: '🇨🇳', phoneCode: '+86', dialCode: '86' },
  { code: 'CO', alpha3: 'COL', name: 'Colombia', flag: '🇨🇴', phoneCode: '+57', dialCode: '57' },
  { code: 'KM', alpha3: 'COM', name: 'Comoros', flag: '🇰🇲', phoneCode: '+269', dialCode: '269' },
  { code: 'CG', alpha3: 'COG', name: 'Congo', flag: '🇨🇬', phoneCode: '+242', dialCode: '242' },
  {
    code: 'CD',
    alpha3: 'COD',
    name: 'Congo (Democratic Republic)',
    flag: '🇨🇩',
    phoneCode: '+243',
    dialCode: '243',
  },
  { code: 'CR', alpha3: 'CRI', name: 'Costa Rica', flag: '🇨🇷', phoneCode: '+506', dialCode: '506' },
  { code: 'HR', alpha3: 'HRV', name: 'Croatia', flag: '🇭🇷', phoneCode: '+385', dialCode: '385' },
  { code: 'CU', alpha3: 'CUB', name: 'Cuba', flag: '🇨🇺', phoneCode: '+53', dialCode: '53' },
  { code: 'CY', alpha3: 'CYP', name: 'Cyprus', flag: '🇨🇾', phoneCode: '+357', dialCode: '357' },
  { code: 'CZ', alpha3: 'CZE', name: 'Czechia', flag: '🇨🇿', phoneCode: '+420', dialCode: '420' },
  { code: 'DK', alpha3: 'DNK', name: 'Denmark', flag: '🇩🇰', phoneCode: '+45', dialCode: '45' },
  { code: 'DJ', alpha3: 'DJI', name: 'Djibouti', flag: '🇩🇯', phoneCode: '+253', dialCode: '253' },
  { code: 'DM', alpha3: 'DMA', name: 'Dominica', flag: '🇩🇲', phoneCode: '+1767', dialCode: '1767' },
  {
    code: 'DO',
    alpha3: 'DOM',
    name: 'Dominican Republic',
    flag: '🇩🇴',
    phoneCode: '+1-809',
    dialCode: '1809',
  },
  { code: 'EC', alpha3: 'ECU', name: 'Ecuador', flag: '🇪🇨', phoneCode: '+593', dialCode: '593' },
  { code: 'EG', alpha3: 'EGY', name: 'Egypt', flag: '🇪🇬', phoneCode: '+20', dialCode: '20' },
  {
    code: 'SV',
    alpha3: 'SLV',
    name: 'El Salvador',
    flag: '🇸🇻',
    phoneCode: '+503',
    dialCode: '503',
  },
  {
    code: 'GQ',
    alpha3: 'GNQ',
    name: 'Equatorial Guinea',
    flag: '🇬🇶',
    phoneCode: '+240',
    dialCode: '240',
  },
  { code: 'ER', alpha3: 'ERI', name: 'Eritrea', flag: '🇪🇷', phoneCode: '+291', dialCode: '291' },
  { code: 'EE', alpha3: 'EST', name: 'Estonia', flag: '🇪🇪', phoneCode: '+372', dialCode: '372' },
  { code: 'ET', alpha3: 'ETH', name: 'Ethiopia', flag: '🇪🇹', phoneCode: '+251', dialCode: '251' },
  { code: 'FJ', alpha3: 'FJI', name: 'Fiji', flag: '🇫🇯', phoneCode: '+679', dialCode: '679' },
  { code: 'FI', alpha3: 'FIN', name: 'Finland', flag: '🇫🇮', phoneCode: '+358', dialCode: '358' },
  { code: 'FR', alpha3: 'FRA', name: 'France', flag: '🇫🇷', phoneCode: '+33', dialCode: '33' },
  { code: 'GA', alpha3: 'GAB', name: 'Gabon', flag: '🇬🇦', phoneCode: '+241', dialCode: '241' },
  { code: 'GM', alpha3: 'GMB', name: 'Gambia', flag: '🇬🇲', phoneCode: '+220', dialCode: '220' },
  { code: 'GE', alpha3: 'GEO', name: 'Georgia', flag: '🇬🇪', phoneCode: '+995', dialCode: '995' },
  { code: 'DE', alpha3: 'DEU', name: 'Germany', flag: '🇩🇪', phoneCode: '+49', dialCode: '49' },
  { code: 'GH', alpha3: 'GHA', name: 'Ghana', flag: '🇬🇭', phoneCode: '+233', dialCode: '233' },
  { code: 'GR', alpha3: 'GRC', name: 'Greece', flag: '🇬🇷', phoneCode: '+30', dialCode: '30' },
  { code: 'GD', alpha3: 'GRD', name: 'Grenada', flag: '🇬🇩', phoneCode: '+1473', dialCode: '1473' },
  { code: 'GU', alpha3: 'GUM', name: 'Guam', flag: '🇬🇺', phoneCode: '+1671', dialCode: '1671' },
  { code: 'GT', alpha3: 'GTM', name: 'Guatemala', flag: '🇬🇹', phoneCode: '+502', dialCode: '502' },
  { code: 'GN', alpha3: 'GIN', name: 'Guinea', flag: '🇬🇳', phoneCode: '+224', dialCode: '224' },
  {
    code: 'GW',
    alpha3: 'GNB',
    name: 'Guinea-Bissau',
    flag: '🇬🇼',
    phoneCode: '+245',
    dialCode: '245',
  },
  { code: 'GY', alpha3: 'GUY', name: 'Guyana', flag: '🇬🇾', phoneCode: '+592', dialCode: '592' },
  { code: 'HT', alpha3: 'HTI', name: 'Haiti', flag: '🇭🇹', phoneCode: '+509', dialCode: '509' },
  { code: 'HN', alpha3: 'HND', name: 'Honduras', flag: '🇭🇳', phoneCode: '+504', dialCode: '504' },
  { code: 'HK', alpha3: 'HKG', name: 'Hong Kong', flag: '🇭🇰', phoneCode: '+852', dialCode: '852' },
  { code: 'HU', alpha3: 'HUN', name: 'Hungary', flag: '🇭🇺', phoneCode: '+36', dialCode: '36' },
  { code: 'IS', alpha3: 'ISL', name: 'Iceland', flag: '🇮🇸', phoneCode: '+354', dialCode: '354' },
  { code: 'IN', alpha3: 'IND', name: 'India', flag: '🇮🇳', phoneCode: '+91', dialCode: '91' },
  { code: 'ID', alpha3: 'IDN', name: 'Indonesia', flag: '🇮🇩', phoneCode: '+62', dialCode: '62' },
  { code: 'IR', alpha3: 'IRN', name: 'Iran', flag: '🇮🇷', phoneCode: '+98', dialCode: '98' },
  { code: 'IQ', alpha3: 'IRQ', name: 'Iraq', flag: '🇮🇶', phoneCode: '+964', dialCode: '964' },
  { code: 'IE', alpha3: 'IRL', name: 'Ireland', flag: '🇮🇪', phoneCode: '+353', dialCode: '353' },
  { code: 'IL', alpha3: 'ISR', name: 'Israel', flag: '🇮🇱', phoneCode: '+972', dialCode: '972' },
  { code: 'IT', alpha3: 'ITA', name: 'Italy', flag: '🇮🇹', phoneCode: '+39', dialCode: '39' },
  { code: 'JM', alpha3: 'JAM', name: 'Jamaica', flag: '🇯🇲', phoneCode: '+1876', dialCode: '1876' },
  { code: 'JP', alpha3: 'JPN', name: 'Japan', flag: '🇯🇵', phoneCode: '+81', dialCode: '81' },
  { code: 'JO', alpha3: 'JOR', name: 'Jordan', flag: '🇯🇴', phoneCode: '+962', dialCode: '962' },
  { code: 'KZ', alpha3: 'KAZ', name: 'Kazakhstan', flag: '🇰🇿', phoneCode: '+7', dialCode: '7' },
  { code: 'KE', alpha3: 'KEN', name: 'Kenya', flag: '🇰🇪', phoneCode: '+254', dialCode: '254' },
  { code: 'KI', alpha3: 'KIR', name: 'Kiribati', flag: '🇰🇮', phoneCode: '+686', dialCode: '686' },
  {
    code: 'KP',
    alpha3: 'PRK',
    name: 'Korea (Democratic Republic)',
    flag: '🇰🇵',
    phoneCode: '+850',
    dialCode: '850',
  },
  {
    code: 'KR',
    alpha3: 'KOR',
    name: 'Korea (Republic)',
    flag: '🇰🇷',
    phoneCode: '+82',
    dialCode: '82',
  },
  { code: 'KW', alpha3: 'KWT', name: 'Kuwait', flag: '🇰🇼', phoneCode: '+965', dialCode: '965' },
  { code: 'KG', alpha3: 'KGZ', name: 'Kyrgyzstan', flag: '🇰🇬', phoneCode: '+996', dialCode: '996' },
  {
    code: 'LA',
    alpha3: 'LAO',
    name: 'Lao People’s Democratic Republic',
    flag: '🇱🇦',
    phoneCode: '+856',
    dialCode: '856',
  },
  { code: 'LB', alpha3: 'LBN', name: 'Lebanon', flag: '🇱🇧', phoneCode: '+961', dialCode: '961' },
  { code: 'LS', alpha3: 'LSO', name: 'Lesotho', flag: '🇱🇸', phoneCode: '+266', dialCode: '266' },
  { code: 'LR', alpha3: 'LBR', name: 'Liberia', flag: '🇱🇷', phoneCode: '+231', dialCode: '231' },
  { code: 'LY', alpha3: 'LBY', name: 'Libya', flag: '🇱🇾', phoneCode: '+218', dialCode: '218' },
  {
    code: 'LI',
    alpha3: 'LIE',
    name: 'Liechtenstein',
    flag: '🇱🇮',
    phoneCode: '+423',
    dialCode: '423',
  },
  { code: 'LT', alpha3: 'LTU', name: 'Lithuania', flag: '🇱🇹', phoneCode: '+370', dialCode: '370' },
  { code: 'LU', alpha3: 'LUX', name: 'Luxembourg', flag: '🇱🇺', phoneCode: '+352', dialCode: '352' },
  { code: 'MO', alpha3: 'MAC', name: 'Macao', flag: '🇲🇴', phoneCode: '+853', dialCode: '853' },
  { code: 'MG', alpha3: 'MDG', name: 'Madagascar', flag: '🇲🇬', phoneCode: '+261', dialCode: '261' },
  { code: 'MW', alpha3: 'MWI', name: 'Malawi', flag: '🇲🇼', phoneCode: '+265', dialCode: '265' },
  { code: 'MY', alpha3: 'MYS', name: 'Malaysia', flag: '🇲🇾', phoneCode: '+60', dialCode: '60' },
  { code: 'MV', alpha3: 'MDV', name: 'Maldives', flag: '🇲🇻', phoneCode: '+960', dialCode: '960' },
  { code: 'ML', alpha3: 'MLI', name: 'Mali', flag: '🇲🇱', phoneCode: '+223', dialCode: '223' },
  { code: 'MT', alpha3: 'MLT', name: 'Malta', flag: '🇲🇹', phoneCode: '+356', dialCode: '356' },
  {
    code: 'MH',
    alpha3: 'MHL',
    name: 'Marshall Islands',
    flag: '🇲🇭',
    phoneCode: '+692',
    dialCode: '692',
  },
  { code: 'MQ', alpha3: 'MTQ', name: 'Martinique', flag: '🇲🇶', phoneCode: '+596', dialCode: '596' },
  { code: 'MR', alpha3: 'MRT', name: 'Mauritania', flag: '🇲🇷', phoneCode: '+222', dialCode: '222' },
  { code: 'MU', alpha3: 'MUS', name: 'Mauritius', flag: '🇲🇺', phoneCode: '+230', dialCode: '230' },
  { code: 'YT', alpha3: 'MYT', name: 'Mayotte', flag: '🇾🇹', phoneCode: '+262', dialCode: '262' },
  { code: 'MX', alpha3: 'MEX', name: 'Mexico', flag: '🇲🇽', phoneCode: '+52', dialCode: '52' },
  {
    code: 'FM',
    alpha3: 'FSM',
    name: 'Micronesia (Federated States of)',
    flag: '🇫🇲',
    phoneCode: '+691',
    dialCode: '691',
  },
  {
    code: 'MD',
    alpha3: 'MDA',
    name: 'Moldova (Republic of)',
    flag: '🇲🇩',
    phoneCode: '+373',
    dialCode: '373',
  },
  { code: 'MC', alpha3: 'MCO', name: 'Monaco', flag: '🇲🇨', phoneCode: '+377', dialCode: '377' },
  { code: 'MN', alpha3: 'MNG', name: 'Mongolia', flag: '🇲🇳', phoneCode: '+976', dialCode: '976' },
  { code: 'ME', alpha3: 'MNE', name: 'Montenegro', flag: '🇲🇪', phoneCode: '+382', dialCode: '382' },
  {
    code: 'MS',
    alpha3: 'MSR',
    name: 'Montserrat',
    flag: '🇲🇸',
    phoneCode: '+1-664',
    dialCode: '1664',
  },
  { code: 'MA', alpha3: 'MAR', name: 'Morocco', flag: '🇲🇦', phoneCode: '+212', dialCode: '212' },
  { code: 'MZ', alpha3: 'MOZ', name: 'Mozambique', flag: '🇲🇿', phoneCode: '+258', dialCode: '258' },
  { code: 'MM', alpha3: 'MMR', name: 'Myanmar', flag: '🇲🇲', phoneCode: '+95', dialCode: '95' },
  { code: 'NA', alpha3: 'NAM', name: 'Namibia', flag: '🇳🇦', phoneCode: '+264', dialCode: '264' },
  { code: 'NR', alpha3: 'NRU', name: 'Nauru', flag: '🇳🇷', phoneCode: '+674', dialCode: '674' },
  { code: 'NP', alpha3: 'NPL', name: 'Nepal', flag: '🇳🇵', phoneCode: '+977', dialCode: '977' },
  { code: 'NL', alpha3: 'NLD', name: 'Netherlands', flag: '🇳🇱', phoneCode: '+31', dialCode: '31' },
  {
    code: 'NC',
    alpha3: 'NCL',
    name: 'New Caledonia',
    flag: '🇳🇨',
    phoneCode: '+687',
    dialCode: '687',
  },
  { code: 'NZ', alpha3: 'NZL', name: 'New Zealand', flag: '🇳🇿', phoneCode: '+64', dialCode: '64' },
  { code: 'NI', alpha3: 'NIC', name: 'Nicaragua', flag: '🇳🇮', phoneCode: '+505', dialCode: '505' },
  { code: 'NE', alpha3: 'NER', name: 'Niger', flag: '🇳🇪', phoneCode: '+227', dialCode: '227' },
  { code: 'NG', alpha3: 'NGA', name: 'Nigeria', flag: '🇳🇬', phoneCode: '+234', dialCode: '234' },
  { code: 'NU', alpha3: 'NIU', name: 'Niue', flag: '🇳🇺', phoneCode: '+683', dialCode: '683' },
  {
    code: 'NF',
    alpha3: 'NFK',
    name: 'Norfolk Island',
    flag: '🇳🇫',
    phoneCode: '+672',
    dialCode: '672',
  },
  {
    code: 'KP',
    alpha3: 'PRK',
    name: 'Korea (Democratic People’s Republic of)',
    flag: '🇰🇵',
    phoneCode: '+850',
    dialCode: '850',
  },
  {
    code: 'MK',
    alpha3: 'MKD',
    name: 'North Macedonia',
    flag: '🇲🇰',
    phoneCode: '+389',
    dialCode: '389',
  },
  {
    code: 'MP',
    alpha3: 'MNP',
    name: 'Northern Mariana Islands',
    flag: '🇲🇵',
    phoneCode: '+1-670',
    dialCode: '1670',
  },
  { code: 'NO', alpha3: 'NOR', name: 'Norway', flag: '🇳🇴', phoneCode: '+47', dialCode: '47' },
  { code: 'OM', alpha3: 'OMN', name: 'Oman', flag: '🇴🇲', phoneCode: '+968', dialCode: '968' },
  { code: 'PK', alpha3: 'PAK', name: 'Pakistan', flag: '🇵🇰', phoneCode: '+92', dialCode: '92' },
  { code: 'PW', alpha3: 'PLW', name: 'Palau', flag: '🇵🇼', phoneCode: '+680', dialCode: '680' },
  {
    code: 'PS',
    alpha3: 'PSE',
    name: 'Palestine, State of',
    flag: '🇵🇸',
    phoneCode: '+970',
    dialCode: '970',
  },
  { code: 'PA', alpha3: 'PAN', name: 'Panama', flag: '🇵🇦', phoneCode: '+507', dialCode: '507' },
  {
    code: 'PG',
    alpha3: 'PNG',
    name: 'Papua New Guinea',
    flag: '🇵🇬',
    phoneCode: '+675',
    dialCode: '675',
  },
  { code: 'PY', alpha3: 'PRY', name: 'Paraguay', flag: '🇵🇾', phoneCode: '+595', dialCode: '595' },
  { code: 'PE', alpha3: 'PER', name: 'Peru', flag: '🇵🇪', phoneCode: '+51', dialCode: '51' },
  { code: 'PH', alpha3: 'PHL', name: 'Philippines', flag: '🇵🇭', phoneCode: '+63', dialCode: '63' },
  { code: 'PN', alpha3: 'PCN', name: 'Pitcairn', flag: '🇵🇳', phoneCode: '+64', dialCode: '64' },
  { code: 'PL', alpha3: 'POL', name: 'Poland', flag: '🇵🇱', phoneCode: '+48', dialCode: '48' },
  { code: 'PT', alpha3: 'PRT', name: 'Portugal', flag: '🇵🇹', phoneCode: '+351', dialCode: '351' },
  {
    code: 'PR',
    alpha3: 'PRI',
    name: 'Puerto Rico',
    flag: '🇵🇷',
    phoneCode: '+1-787',
    dialCode: '1787',
  },
  { code: 'QA', alpha3: 'QAT', name: 'Qatar', flag: '🇶🇦', phoneCode: '+974', dialCode: '974' },
  { code: 'RE', alpha3: 'REU', name: 'Réunion', flag: '🇷🇪', phoneCode: '+262', dialCode: '262' },
  { code: 'RO', alpha3: 'ROU', name: 'Romania', flag: '🇷🇴', phoneCode: '+40', dialCode: '40' },
  {
    code: 'RU',
    alpha3: 'RUS',
    name: 'Russian Federation',
    flag: '🇷🇺',
    phoneCode: '+7',
    dialCode: '7',
  },
  { code: 'RW', alpha3: 'RWA', name: 'Rwanda', flag: '🇷🇼', phoneCode: '+250', dialCode: '250' },
  {
    code: 'BL',
    alpha3: 'BLM',
    name: 'Saint Barthélemy',
    flag: '🇧🇱',
    phoneCode: '+590',
    dialCode: '590',
  },
  {
    code: 'SH',
    alpha3: 'SHN',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    flag: '🇸🇭',
    phoneCode: '+290',
    dialCode: '290',
  },
  {
    code: 'KN',
    alpha3: 'KNA',
    name: 'Saint Kitts and Nevis',
    flag: '🇰🇳',
    phoneCode: '+1-869',
    dialCode: '1869',
  },
  {
    code: 'LC',
    alpha3: 'LCA',
    name: 'Saint Lucia',
    flag: '🇱🇨',
    phoneCode: '+1-758',
    dialCode: '1758',
  },
  {
    code: 'MF',
    alpha3: 'MAF',
    name: 'Saint Martin (French part)',
    flag: '🇲🇫',
    phoneCode: '+590',
    dialCode: '590',
  },
  {
    code: 'PM',
    alpha3: 'SPM',
    name: 'Saint Pierre and Miquelon',
    flag: '🇵🇲',
    phoneCode: '+508',
    dialCode: '508',
  },
  {
    code: 'VC',
    alpha3: 'VCT',
    name: 'Saint Vincent and the Grenadines',
    flag: '🇻🇨',
    phoneCode: '+1-784',
    dialCode: '1784',
  },
  { code: 'WS', alpha3: 'WSM', name: 'Samoa', flag: '🇼🇸', phoneCode: '+685', dialCode: '685' },
  { code: 'SM', alpha3: 'SMR', name: 'San Marino', flag: '🇸🇲', phoneCode: '+378', dialCode: '378' },
  {
    code: 'ST',
    alpha3: 'STP',
    name: 'Sao Tome and Principe',
    flag: '🇸🇹',
    phoneCode: '+239',
    dialCode: '239',
  },
  {
    code: 'SA',
    alpha3: 'SAU',
    name: 'Saudi Arabia',
    flag: '🇸🇦',
    phoneCode: '+966',
    dialCode: '966',
  },
  { code: 'SN', alpha3: 'SEN', name: 'Senegal', flag: '🇸🇳', phoneCode: '+221', dialCode: '221' },
  { code: 'RS', alpha3: 'SRB', name: 'Serbia', flag: '🇷🇸', phoneCode: '+381', dialCode: '381' },
  { code: 'SC', alpha3: 'SYC', name: 'Seychelles', flag: '🇸🇨', phoneCode: '+248', dialCode: '248' },
  {
    code: 'SL',
    alpha3: 'SLE',
    name: 'Sierra Leone',
    flag: '🇸🇱',
    phoneCode: '+232',
    dialCode: '232',
  },
  { code: 'SG', alpha3: 'SGP', name: 'Singapore', flag: '🇸🇬', phoneCode: '+65', dialCode: '65' },
  {
    code: 'SX',
    alpha3: 'SXM',
    name: 'Sint Maarten (Dutch part)',
    flag: '🇸🇽',
    phoneCode: '+1-721',
    dialCode: '1721',
  },
  { code: 'SK', alpha3: 'SVK', name: 'Slovakia', flag: '🇸🇰', phoneCode: '+421', dialCode: '421' },
  { code: 'SI', alpha3: 'SVN', name: 'Slovenia', flag: '🇸🇮', phoneCode: '+386', dialCode: '386' },
  {
    code: 'SB',
    alpha3: 'SLB',
    name: 'Solomon Islands',
    flag: '🇸🇧',
    phoneCode: '+677',
    dialCode: '677',
  },
  { code: 'SO', alpha3: 'SOM', name: 'Somalia', flag: '🇸🇴', phoneCode: '+252', dialCode: '252' },
  { code: 'ZA', alpha3: 'ZAF', name: 'South Africa', flag: '🇿🇦', phoneCode: '+27', dialCode: '27' },
  {
    code: 'GS',
    alpha3: 'SGS',
    name: 'South Georgia and the South Sandwich Islands',
    flag: '🇬🇸',
    phoneCode: '+500',
    dialCode: '500',
  },
  {
    code: 'KR',
    alpha3: 'KOR',
    name: 'Korea (Republic of)',
    flag: '🇰🇷',
    phoneCode: '+82',
    dialCode: '82',
  },
  {
    code: 'SS',
    alpha3: 'SSD',
    name: 'South Sudan',
    flag: '🇸🇸',
    phoneCode: '+211',
    dialCode: '211',
  },
  { code: 'ES', alpha3: 'ESP', name: 'Spain', flag: '🇪🇸', phoneCode: '+34', dialCode: '34' },
  { code: 'LK', alpha3: 'LKA', name: 'Sri Lanka', flag: '🇱🇰', phoneCode: '+94', dialCode: '94' },
  { code: 'SD', alpha3: 'SDN', name: 'Sudan', flag: '🇸🇩', phoneCode: '+249', dialCode: '249' },
  { code: 'SR', alpha3: 'SUR', name: 'Suriname', flag: '🇸🇷', phoneCode: '+597', dialCode: '597' },
  {
    code: 'SJ',
    alpha3: 'SJM',
    name: 'Svalbard and Jan Mayen',
    flag: '🇸🇯',
    phoneCode: '+47',
    dialCode: '47',
  },
  { code: 'SE', alpha3: 'SWE', name: 'Sweden', flag: '🇸🇪', phoneCode: '+46', dialCode: '46' },
  { code: 'CH', alpha3: 'CHE', name: 'Switzerland', flag: '🇨🇭', phoneCode: '+41', dialCode: '41' },
  {
    code: 'SY',
    alpha3: 'SYR',
    name: 'Syrian Arab Republic',
    flag: '🇸🇾',
    phoneCode: '+963',
    dialCode: '963',
  },
  {
    code: 'TW',
    alpha3: 'TWN',
    name: 'Taiwan, Province of China',
    flag: '🇹🇼',
    phoneCode: '+886',
    dialCode: '886',
  },
  { code: 'TJ', alpha3: 'TJK', name: 'Tajikistan', flag: '🇹🇯', phoneCode: '+992', dialCode: '992' },
  {
    code: 'TZ',
    alpha3: 'TZA',
    name: 'Tanzania, United Republic of',
    flag: '🇹🇿',
    phoneCode: '+255',
    dialCode: '255',
  },
  { code: 'TH', alpha3: 'THA', name: 'Thailand', flag: '🇹🇭', phoneCode: '+66', dialCode: '66' },
  {
    code: 'TL',
    alpha3: 'TLS',
    name: 'Timor-Leste',
    flag: '🇹🇱',
    phoneCode: '+670',
    dialCode: '670',
  },
  { code: 'TG', alpha3: 'TGO', name: 'Togo', flag: '🇹🇬', phoneCode: '+228', dialCode: '228' },
  { code: 'TK', alpha3: 'TKL', name: 'Tokelau', flag: '🇹🇰', phoneCode: '+690', dialCode: '690' },
  { code: 'TO', alpha3: 'TON', name: 'Tonga', flag: '🇹🇴', phoneCode: '+676', dialCode: '676' },
  {
    code: 'TT',
    alpha3: 'TTO',
    name: 'Trinidad and Tobago',
    flag: '🇹🇹',
    phoneCode: '+1-868',
    dialCode: '1868',
  },
  { code: 'TN', alpha3: 'TUN', name: 'Tunisia', flag: '🇹🇳', phoneCode: '+216', dialCode: '216' },
  { code: 'TR', alpha3: 'TUR', name: 'Türkiye', flag: '🇹🇷', phoneCode: '+90', dialCode: '90' },
  {
    code: 'TM',
    alpha3: 'TKM',
    name: 'Turkmenistan',
    flag: '🇹🇲',
    phoneCode: '+993',
    dialCode: '993',
  },
  {
    code: 'TC',
    alpha3: 'TCA',
    name: 'Turks and Caicos Islands',
    flag: '🇹🇨',
    phoneCode: '+1-649',
    dialCode: '1649',
  },
  { code: 'TV', alpha3: 'TUV', name: 'Tuvalu', flag: '🇹🇻', phoneCode: '+688', dialCode: '688' },
  { code: 'UG', alpha3: 'UGA', name: 'Uganda', flag: '🇺🇬', phoneCode: '+256', dialCode: '256' },
  { code: 'UA', alpha3: 'UKR', name: 'Ukraine', flag: '🇺🇦', phoneCode: '+380', dialCode: '380' },
  {
    code: 'AE',
    alpha3: 'UAE',
    name: 'United Arab Emirates',
    flag: '🇦🇪',
    phoneCode: '+971',
    dialCode: '971',
  },
  {
    code: 'GB',
    alpha3: 'GBR',
    name: 'United Kingdom of Great Britain and Northern Ireland',
    flag: '🇬🇧',
    phoneCode: '+44',
    dialCode: '44',
  },
  {
    code: 'US',
    alpha3: 'USA',
    name: 'United States of America',
    flag: '🇺🇸',
    phoneCode: '+1',
    dialCode: '1',
  },
  {
    code: 'UM',
    alpha3: 'UMI',
    name: 'United States Minor Outlying Islands',
    flag: '🇺🇲',
    phoneCode: '+1',
    dialCode: '1',
  },
  { code: 'UY', alpha3: 'URY', name: 'Uruguay', flag: '🇺🇾', phoneCode: '+598', dialCode: '598' },
  { code: 'UZ', alpha3: 'UZB', name: 'Uzbekistan', flag: '🇺🇿', phoneCode: '+998', dialCode: '998' },
  { code: 'VU', alpha3: 'VUT', name: 'Vanuatu', flag: '🇻🇺', phoneCode: '+678', dialCode: '678' },
  {
    code: 'VE',
    alpha3: 'VEN',
    name: 'Venezuela (Bolivarian Republic of)',
    flag: '🇻🇪',
    phoneCode: '+58',
    dialCode: '58',
  },
  { code: 'VN', alpha3: 'VNM', name: 'Viet Nam', flag: '🇻🇳', phoneCode: '+84', dialCode: '84' },
  {
    code: 'VG',
    alpha3: 'VGB',
    name: 'Virgin Islands (British)',
    flag: '🇻🇬',
    phoneCode: '+1-284',
    dialCode: '1284',
  },
  {
    code: 'VI',
    alpha3: 'VIR',
    name: 'Virgin Islands (U.S.)',
    flag: '🇻🇮',
    phoneCode: '+1-340',
    dialCode: '1340',
  },
  {
    code: 'WF',
    alpha3: 'WLF',
    name: 'Wallis and Futuna',
    flag: '🇼🇫',
    phoneCode: '+681',
    dialCode: '681',
  },
  {
    code: 'EH',
    alpha3: 'ESH',
    name: 'Western Sahara',
    flag: '🇪🇭',
    phoneCode: '+212',
    dialCode: '212',
  },
  { code: 'YE', alpha3: 'YEM', name: 'Yemen', flag: '🇾🇪', phoneCode: '+967', dialCode: '967' },
  { code: 'ZM', alpha3: 'ZMB', name: 'Zambia', flag: '🇿🇲', phoneCode: '+260', dialCode: '260' },
  { code: 'ZW', alpha3: 'ZWE', name: 'Zimbabwe', flag: '🇿🇼', phoneCode: '+263', dialCode: '263' },
];

// Default country (UAE)
export const defaultCountry =
  countryPhoneCodes.find((country) => country.code === 'UAE') || countryPhoneCodes[0];

// Helper function to get country by phone code
export const getCountryByPhoneCode = (phoneCode: string): CountryPhoneCode | undefined => {
  return countryPhoneCodes.find((country) => country.phoneCode === phoneCode);
};

// Helper function to get country by code
export const getCountryByCode = (code: string): CountryPhoneCode | undefined => {
  return countryPhoneCodes.find((country) => country.code === code);
};
